export default __webpack_public_path__ + "static/beauty-hero-493a0a60b916f9e827a84e8af518304e.jpg";